import React from "react";
import "./Notification.css"
import { STORAGE_KEYS } from "../../utils/constants";


/**
 * Notification Module
 * @module Notification
 */
/**
 * A React component that creates an iframe that loads a Microsoft Teams web app,
 * which is used to send notifications to the user.
 *
 * The iframe is loaded with the URL of the Teams web app, and is passed the
 * necessary parameters to send the notification. The parameters are encoded in
 * the URL, and are as follows:
 *
 * - port_no: The port number to use when sending the notification.
 * - bot_id: The ID of the bot that is sending the notification.
 * - auth_token: The authentication token to use when sending the notification.
 * - context: A JSON object that contains the context of the notification.
 *   The context object contains the following properties:
 *   - chatId: The ID of the chat where the notification should be sent.
 *   - userObjectId: The ID of the user to send the notification to.
 *   - meetingId: The ID of the meeting where the notification should be sent.
 *   - userPrincipalName: The UPN of the user to send the notification to.
 *   - tid: The tenant ID of the user to send the notification to.
 *   - destination_id: The ID of the user to send the notification to.
 *   - channelId: The channel ID of the chat where the notification should be sent.
 *   - user_id: The ID of the user to send the notification to.
 *   - id: A unique ID for the notification.
 *   - entityId: The ID of the entity that is sending the notification.
 *   - subEntityId: The ID of the sub-entity that is sending the notification.
 *
 * The notification is sent by the Teams web app, and is displayed to the user.
 *
 * @returns {JSX.Element} The JSX element that represents the iframe.
 * @example
 * <Notification />
 */
const Notification = () => {

    const info = {
      ...JSON.parse(localStorage.getItem(STORAGE_KEYS.SESSION)),
    };
    const params = {
      port_no: "0000",
      bot_id: info.bot_id,
      auth_token: info.token,
      context: JSON.stringify({
        chatId: "",
        userObjectId: info.aad_object_id,
        meetingId: "",
        userPrincipalName: info.email,
        tid: info.tenantId,
        destination_id: info.aad_object_id,
        channelId: "msteams",
        user_id: info.aad_object_id,
        id: -1,
        entityId: info.bot_id,
        subEntityId: "",
      }),
    };
    params.context = encodeURIComponent(params.context);

    const queryString = Object.keys(params)
      .map((key) => `${key}=${params[key]}`)
      .join("&");

    /**
     * @inner
     * @constant {string} teamsUrl
     * @description The URL of the Teams web app that is used to send notifications.
     * The URL is constructed using the base URL of the Teams web app, and the
     * query string that contains the parameters for sending the notification.
     */
    const teamsUrl = `${info.add_on_base_url}notifications?${queryString}::dp::${queryString}::dp::${info.tenantId}`;
    



  return (
    <div className="notification">
      <iframe
        allow="autoplay"
        height={"100%"}
        width={"100%"}
        id="ifr"
        allowFullScreen={true}
        style={{ border: "none" }}
        src={teamsUrl}
        title="notification_iframe"
      ></iframe>
    </div>
  );
};

export default Notification;
